import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import onPageRender from '../hocs/onPageRender'
import Container from '../components/Container/Container'
import LegalContent from '../components/LegalContent/LegalContent'
import SectionTitle, {
  TITLE_TYPES,
} from '../components/SectionTitle/SectionTitle'
import Seo from '../components/Seo/Seo'

const LegalPage = ({
  data: {
    page: { data },
  },
}) => {
  const {
    title: { text: title },
    description: { html: description },
  } = data
  return (
    <Container>
      <Seo title={title} />
      <div className="pt-10">
        <SectionTitle
          text={title}
          type={TITLE_TYPES.HANDWRITTEN_ALPHA}
          htmlElement="h1"
        />
      </div>
      <div className="mx-auto max-w-xl">
        <LegalContent html={description} />
      </div>
    </Container>
  )
}

LegalPage.propTypes = {
  data: PropTypes.object,
}

export default onPageRender(LegalPage)

export const query = graphql`
  query($id: String!) {
    page: prismicLegalPage(id: { eq: $id }) {
      data {
        title {
          text
        }
        description {
          html
        }
      }
    }
  }
`
